<template>
  <!--Waiting for Vue 3 for multiply slots refactoring-->
  <div
    class="v-system-message__wrapper"
    :class="{ ['with-social-networks']: socialNetworks }"
  >
    <div class="v-system-message__container" :class="{ [size]: true }">
      <div v-if="inkitLogo" class="v-system-message__logo">
        <img :src="logo" alt="logo" />
      </div>
      <div v-if="title" class="v-system-message__title">{{ title }}</div>
      <div v-if="primaryText" class="v-system-message__primary-text">
        {{ primaryText }}
      </div>
      <pre class="v-system-message__secondary-text">{{ secondaryText }}</pre>
      <slot></slot>
      <div v-if="actions" class="v-system-message__actions">
        <div v-for="(action, idx) of actions" :key="idx">
          <v-button v-bind="action" @click="onClickAction(action)"></v-button>
        </div>
      </div>
    </div>

    <div
      v-if="socialNetworks"
      class="v-system-message__social-networks-container"
    >
      <VSocialNetworkIcons
        :socialNetworks="socialNetworks"
      ></VSocialNetworkIcons>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";

import Layout from "@/layouts/Layout";
import mainLogo from "@/assets/images/logo-w-container.svg";
import VSocialNetworkIcons from "@/components/VSocialNetworkIcons";

export default Vue.component("VSystemMessage", {
  props: {
    inkitLogo: VueTypes.bool,
    title: VueTypes.string,
    primaryText: VueTypes.string,
    secondaryText: VueTypes.string,
    size: VueTypes.oneOf(["small"]),
    actions: VueTypes.arrayOf(
      VueTypes.shape({
        label: VueTypes.string.isRequired,
        value: VueTypes.string.isRequired,
        type: VueTypes.string.def("primary"),
        noBorder: VueTypes.bool.def(false),
        inverted: VueTypes.bool.def(false),
        disabled: VueTypes.bool.def(false),
        size: VueTypes.string,
        click: VueTypes.oneOfType([VueTypes.func, VueTypes.string]).isRequired
      })
    ),
    socialNetworks: VueTypes.oneOfType([VueTypes.array, VueTypes.undefined])
  },

  data() {
    return {
      logo: mainLogo
    };
  },

  components: {
    Layout,
    VSocialNetworkIcons
  },

  methods: {
    onClickAction(action) {
      if (typeof action.click === "string") {
        this.$emit(action.click, action.value);
      } else {
        action.click(action.value);
      }
    }
  }
});
</script>

<style lang="scss" scoped>
$ns: "v-system-message";

.#{$ns}__wrapper {
  &,
  .#{$ns}__container {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
}

.with-social-networks {
  .#{$ns}__social-networks-container {
    margin-top: 50px;
  }
}

.#{$ns}__container {
  padding: 40px 25px;
  background: $white;
  width: 486px;
  min-height: 496px;
  box-shadow: 2px 2px 25px rgba(0, 0, 0, 0.15);
  border-radius: 5px;

  &.small {
    min-height: 340px;
  }
}

.#{$ns}__logo {
  img {
    height: 50px;
  }

  margin-bottom: 45px;
}

.#{$ns}__title {
  font-size: 32px;
  font-family: Lato-Bold, Arial, sans-serif;
  line-height: 1.2;
}

.#{$ns}__primary-text {
  color: $primary-color;
  margin-bottom: 15px;
  font-size: 30px;
  line-height: 1.2;
}

.#{$ns}__secondary-text {
  font-size: 16px;
  font-family: Lato-Light, Arial, Helvetica Neue, Helvetica, sans-serif;
  line-height: 1.6;
}

.#{$ns}__actions {
  margin-top: 58px;

  & > * {
    margin-top: 15px;
  }

  div:first-child {
    margin-top: 0;
  }
}

/*Media*/
@media only screen and (max-width: 600px) {
  .#{$ns}__container {
    box-shadow: none;
    width: 100%;
    min-height: 438px;
    font-size: 14px;
  }

  .#{$ns}__primaryText {
    font-size: 26px;
  }

  .#{$ns}__logo {
    img {
      height: 40px;
    }

    margin-bottom: 20px;
  }

  .v-system-message__container /deep/ .btn {
    margin: 47px 0;

    button {
      min-width: 260px;
      span {
        font-size: 14px;
      }
    }
  }

  &.with-social-networks {
    .#{$ns}__social-networks-container {
      margin-top: 0;
    }
  }
}
</style>
